import api from '@/services/api'

const moduleAuth = {
  state: {
    user: {},
    token: localStorage.getItem('user-token') || ''
  },
  mutations: {
    AUTH_TOKEN: (state, token) => {
      state.token = token
    },
    AUTH_USER(state, data) {
      state.user = data
    }
  },
  actions: {
    AUTH_REQUEST: ({ commit }, { username, password, remember }) => {
      return new Promise((resolve, reject) => { // Возвращаем промис для продолжения "цепочки" запросов
        api.post('/auth/login/', { username, password })
          .then(response => {
            const token = response.data.key
            commit('AUTH_TOKEN', token)
            // Сохраняем токен, если выбрана галочка "Запомнить"
            if (remember) {
              localStorage.setItem('user-token', token)
            }
            // Добавляем токен в headers
            api.defaults.headers
            .common['Authorization'] = `Token ${token}`

            resolve(response)
          })
          .catch(error => {
            localStorage.removeItem('user-token')
            reject(error)
          })
      })
    },
    AUTH_LOGOUT_REQUEST({ commit }) {
      return new Promise((resolve, reject) => { // Возвращаем промис для продолжения "цепочки" запросов
        api.post('/auth/logout/')
        .then(response => resolve(response))
        .catch(error => reject(error))
        .finally(() => {
          commit('AUTH_TOKEN', '')
          delete api.defaults.headers.common['Authorization']
          localStorage.clear()
        })
      })
    },
    AUTH_USER_REQUEST({ commit }) {
      return new Promise((resolve, reject) => { // Возвращаем промис для продолжения "цепочки" запросов
        api.get('/auth/user/')
        .then(response => {
          if (response.data) {
            commit('AUTH_USER', response.data)
          }
          resolve(response)
        })
        .catch(error => {
          if (error.response.status === 401) {
            localStorage.removeItem('user-token')
          }
          reject(error)
        })
      })
    },
  },
  getters: {
    AUTH_USER: state => state.user,
    isAuthenticated: state => !!state.token
  }
}
export default moduleAuth